import { AppState, RedirectLoginOptions } from "@auth0/auth0-react";

/* istanbul ignore file */
export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const sample = (list) => list[Math.floor(Math.random() * list.length)];
export const rootUrl = (location) => location.protocol + "//" + location.host;

export const auth0LoginOptions = ({
  target = undefined,
  organization = undefined,
} = {}): RedirectLoginOptions<AppState> => {
  return {
    authorizationParams: {
      organization,
    },
    appState: {
      returnTo: `${window.location.origin}/-/callback/auth`,
      target: target || window.location.pathname + window.location.search,
    },
  };
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function splitEmailList(emails: string) {
  return (emails || "").split(/[\s,]+/).filter((e) => e !== "");
}
